import { useState } from "react";
import {
    useStripe,
    useElements,
    PaymentElement,
} from "@stripe/react-stripe-js";

import { Button, Snackbar, Alert, CircularProgress } from "@mui/material";

import { request } from "@/Api";

export default function PaymentUpdateForm({ handleSuccess }) {
    const stripe = useStripe();
    const elements = useElements();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        setError("");
        setLoading(true);

        const { setupIntent, error } = await stripe.confirmSetup({
            elements,
            redirect: "if_required",
        });

        if (error) {
            setError(error.message);
            setLoading(false);
            return;
        }

        request
            .post("/payments/default-payment-method", {
                payment_method_id: setupIntent.payment_method,
            })
            .then((response) => {
                handleSuccess(response.data);
            })
            .catch(() => {
                setError("Failed to update payment method");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleCloseError = () => {
        setError("");
    };

    return (
        <form onSubmit={handleSubmit}>
            <PaymentElement />

            <Button
                type="submit"
                variant="contained"
                size="large"
                color="primary"
                sx={{ color: "white", margin: "36px 0 16px 0" }}
                fullWidth
                disabled={loading}
            >
                {loading ? <CircularProgress size={26} /> : "Save"}
            </Button>

            <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                open={error != ""}
                onClose={handleCloseError}
            >
                <Alert
                    variant="filled"
                    severity="error"
                    sx={{ width: "100%" }}
                    onClose={handleCloseError}
                >
                    {error}
                </Alert>
            </Snackbar>
        </form>
    );
}
